import { QuestLogo } from "./quest-logo";

interface PointsLabelProps {
  points: number;
  className?: string;
}

export const PointsLabel = ({ points, className = "" }: PointsLabelProps) => {
  return (
    <div className={`absolute top-4 left-4 flex items-center gap-2 bg-white/20 backdrop-blur-sm rounded-full px-3 py-1.5 ${className}`}>
      <QuestLogo size={16} className="w-4 h-4" />
      <span className="text-sm font-bold text-spicenet-primary">
        {points}
      </span>
    </div>
  );
};